import React from 'react'
import "./fifth.css"
function Third() {
  return (
    <div className="d1 fifth" style={{background:"#D6184D"}}>
<div className='text'>
  <span className='title'>
  run is
  <br/>
now social

  </span><br/>
<span>
Make new friends or talk to old ones. Learn from their experiences or ask them a question. Get some motivation and help someone
</span>
<button className='btn' href="#">Know More</button>

</div>
<div className='img-fifth'>
<img src="third.png"/>
</div>
     </div>
);
    }
    
   
export default Third;